import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-autorenewalonwidget',
  templateUrl: './autorenewalonwidget.component.html',
  styleUrls: ['./autorenewalonwidget.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AutorenewalonwidgetComponent implements OnInit {

  public fetchAutoRenewalOn$ = this.dashboardFacade$.autoRenewalOn$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchAutoRenewalOn()
  }

}